<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zkgrpP/tc-custom/9781504088787.jpg?1706124137801" alt="This image is the cover for the book Ex Agreement"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ex Agreement
      </h1>
      <p class="bookDescription body article font2">
        <b>Can they put up a happy front for one more holiday? A compelling new novel of marriage and misgivings from the author of <i>The Two-Week Promise.</i></b><br/><br/> Charlotte and Bryan have been separated for six months, disappointed that the fairy-tale future they imagined at their wedding didn’t quite come true. Bryan, a policeman, was constantly working, while Charlotte struggled with household finances and a baby. And their son’s recently diagnosed autism has caused further strain.<br/><br/> However, there’s one thing Bryan hasn’t managed to get around to: telling his parents about the separation. Now, as Christmas approaches, he asks Charlotte to play along and construct a festive façade during the holiday visit. But just like fairy tales, family gatherings never seem to go as planned—and the couple will finally have to figure out if the New Year will mark the end of their marriage or a resolution to begin again . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Regina Brownell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b0717c9